module.exports = __webpack_public_path__ + "files/5c31c87ae99060c126ece8209fc16309.png";